(()=>{if(window.K2RelatedLoaded){window.K2RelatedBoot?.(document);return;}window.K2RelatedLoaded=true;
  async function openThemeCartDrawer(item) {
    const cartPageUrl = window.theme?.routes?.cart ||
      `${window.Shopify?.routes?.root || '/'}cart`;
    const rootUrl = window.theme?.routes?.root_url || window.Shopify?.routes?.root || '/';
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) {
      window.location.assign(cartPageUrl);
      return false;
    }

    // This timeout protects read requests only. Never retry the successful add.
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    const readSection = async name => {
      const bundled = item?.sections?.[name];
      if (typeof bundled === 'string' && bundled.trim()) return bundled;
      const response = await fetch(`${rootUrl}?section_id=${encodeURIComponent(name)}`, {
        headers: { Accept: 'text/html' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error(`Unable to refresh ${name}.`);
      return response.text();
    };

    try {
      const readCart = async () => {
        const response = await fetch(`${cartPageUrl}.js`, {
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Unable to refresh cart data.');
        const cart = await response.json();
        if (!cart || !Number.isInteger(cart.item_count) ||
            !Number.isFinite(cart.total_price)) {
          throw new Error('Invalid cart response.');
        }
        return cart;
      };

      // Missing bundled sections fall back to concurrent reads, not another add.
      const [cart, itemsHTML, subtotalHTML] = await Promise.all([
        readCart(),
        readSection('api-cart-items'),
        readSection('api-cart-subtotal')
      ]);
      const detail = {
        cart,
        sections: {
          'api-cart-items': itemsHTML,
          'api-cart-subtotal': subtotalHTML
        },
        rendered: false,
        error: null
      };

      // The paired Pipeline listener renders synchronously and acknowledges it.
      drawer.dispatchEvent(new CustomEvent('keith:cart:render', { detail }));
      if (!detail.rendered) {
        throw detail.error || new Error('The cart renderer is not ready.');
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, item } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart, item } }));
      if (!drawer.classList.contains('drawer--visible')) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
      }
      return true;
    } catch (error) {
      controller.abort();
      console.warn('[Keith] Cart added; opening the full cart:', error);
      window.location.assign(cartPageUrl);
      return false;
    } finally {
      clearTimeout(timeout);
    }
  }

function slider(el){const track=el.querySelector('[data-kr-track]');if(!track)return;const count=track.children.length;if(count>4)track.dataset.slider='true';const nav=el.querySelector('[data-kr-nav]');const prev=el.querySelector('[data-kr-prev]'),next=el.querySelector('[data-kr-next]');if(!nav)return;const sync=()=>{const overflow=track.scrollWidth>track.clientWidth+2;nav.hidden=!overflow;prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};if(!el.dataset.sliderReady){el.dataset.sliderReady='true';prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));track.addEventListener('scroll',sync,{passive:true});if(window.ResizeObserver)new ResizeObserver(sync).observe(track);}requestAnimationFrame(sync);}
async function load(el){if(el.dataset.loading)return;el.dataset.loading='true';try{const r=await fetch(el.dataset.autoUrl,{headers:{Accept:'text/html'}});if(!r.ok)throw Error('Recommendation request failed');const doc=new DOMParser().parseFromString(await r.text(),'text/html');const fresh=doc.getElementById(el.id);if(fresh&&!fresh.hasAttribute('data-auto-url')){el.replaceWith(fresh);slider(fresh);}}catch(e){console.warn('[KEITH recommendations]',e);delete el.dataset.loading;}}
function boot(root){root.querySelectorAll('[data-k2-related]').forEach(el=>{slider(el);if(el.dataset.autoUrl)load(el);});}window.K2RelatedBoot=boot;boot(document);document.addEventListener('shopify:section:load',e=>boot(e.target));
document.addEventListener('click',async e=>{const button=e.target.closest('[data-kr-add]');if(!button)return;e.preventDefault();e.stopImmediatePropagation();if(button.disabled)return;button.disabled=true;const status=button.closest('article').querySelector('[data-kr-status]');status.textContent='';button.textContent='Adding…';let uncertain=false;try{const body=new FormData();body.set('id',button.dataset.krAdd);body.set('quantity','1');body.set('sections','api-cart-items,api-cart-subtotal');body.set('sections_url',window.Shopify?.routes?.root||'/');let r;try{r=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body});}catch(err){uncertain=true;throw err;}if(!r.ok){if(r.status===400||r.status>=500)uncertain=true;let data={};try{data=await r.json();}catch{}throw Error(typeof data.description==='string'?data.description:'Unable to add this product.');}let item;try{item=await r.json();}catch{window.location.assign(window.theme?.routes?.cart||`${window.Shopify?.routes?.root||'/'}cart`);return;}status.textContent='Added to cart';await openThemeCartDrawer(item);}catch(err){if(uncertain){status.textContent='Please check your cart before trying again. ';const a=document.createElement('a');a.href=window.theme?.routes?.cart||`${window.Shopify?.routes?.root||'/'}cart`;a.textContent='View cart';status.append(a);}else status.textContent=err.message;}finally{button.disabled=uncertain;button.textContent=uncertain?'Check cart':button.dataset.label;}},true);
})();